import { render, staticRenderFns } from "./Localizations.vue?vue&type=template&id=1eab700a"
import script from "./Localizations.vue?vue&type=script&lang=js"
export * from "./Localizations.vue?vue&type=script&lang=js"
import style0 from "./Localizations.vue?vue&type=style&index=0&id=1eab700a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports